export const Roles = {
  Developer: "MIDAS.DEVELOPER",
  MidasGuest: "MIDAS.Guest",
  MidasMember: "MIDAS.Member",
  MidasOnPremMember: "MIDAS.OnPremMember",

  AnalyticalSME: "ANALYTICAL.SME",
  AnalyticalWorker: "ANALYTICAL.WORKER",
  BlendFormulator: "BLEND.FORMULATOR",
  BlendSME: "BLEND.SME",
  BlendWorker: "BLEND.WORKER",
  DistillationSME: "DISTILLATION.SME",
  DistillationWorker: "DISTILLATION.WORKER",
  EMBSIWorker: "EMBSI.WORKER",
  ProjectSME: "PROJECT.SME",
  SdsRequestWorker: "SDSREQUEST.WORKER",
  SHESME: "SHE.SME",
  SiteSME: "SITE.SME",
  SpecialAnalysisWorker: "SPECIALANALYSIS.WORKER",
  SQCSME: "SQC.SME",
  SQCViewer: "SQC.VIEWER",
  SQCWorker: "SQC.WORKER",
  StationaryTestingSME: "STATIONARYTESTING.SME",
  StationaryTestingWorker: "STATIONARYTESTING.WORKER",
  STLCSME: "STLC.SME",
  StockroomWorker: "STOCKROOM.WORKER",
  WorkRequestSME: "WORKREQUEST.SME",
  WorkRequestWorker: "WORKREQUEST.WORKER",
} as const;

export const RolesAdfs = [
  Roles.MidasOnPremMember,
  Roles.AnalyticalWorker,
  Roles.BlendWorker,
  Roles.StationaryTestingWorker,
  Roles.SQCWorker,
  Roles.SQCViewer
] as const;

export const InternalUserRoles = [Roles.Developer, Roles.MidasMember, Roles.MidasOnPremMember];

export const InternalAndGuestUserRoles = [...InternalUserRoles, Roles.MidasGuest];

export type Role = (typeof Roles)[keyof typeof Roles];
